export default "__VITE_ASSET__DyUgfToU__"